import {create} from 'zustand';
import {GridSortModel} from '@mui/x-data-grid';
import _get from 'lodash/get';
import {SelectChangeEvent} from '@mui/material';
import {toNumber} from 'lodash';

interface ContractTableState {
  archive: boolean;
  page: number;
  size: number;
  sortModel?: GridSortModel | undefined;
  order: () => string;

  setContractTableArchive: (archive: boolean) => void;
  setContractTablePage: (_: unknown, page: number) => void;
  setContractTableSize: (e: SelectChangeEvent<number>) => void;
  setContractTableSort: (sortModel: GridSortModel) => void;
}

export const useContractsTableStore = create<ContractTableState>((set, get) => ({
  archive: false,
  page: 0,
  size: 100,
  sort: undefined,
  order: () => {
    const sort = _get(get(), 'sortModel.[0]');
    if (!sort) return '';
    return `${sort?.field},${sort?.sort}`;
  },

  setContractTableArchive: (archive) => set({archive}),
  setContractTablePage: (_, page) => set({page}),
  setContractTableSize: (e) => set({size: toNumber(_get(e, 'target.value', 5))}),
  setContractTableSort: (sortModel) => set({sortModel}),
}));

export const {setContractTablePage, setContractTableSize, setContractTableSort, setContractTableArchive} =
  useContractsTableStore.getState();
